import { createPlatformState } from '~/helpers/store'

export default () => {
  const state = createPlatformState()

  return {
    ...state,
    cached: {},
    meta: {
      ...state.meta,
      membersEventFetching: false,
      inductionFetching: false,
      screeningFetching: false,
      fitnessFetching: false,
      membersEventFetched: false,
      inductionFetched: false,
      screeningFetched: false,
      fitnessFetched: false
    }
  }
}
